var React = require( 'react' );
var createReactClass = require('create-react-class');
var ContentMarkDown = require('../../../components/contentMarkDown.jsx');
var Photo = require('./photo.jsx');
var Video = require('./video.jsx');
var Audio = require('./audio.jsx');

var ContentSlot = createReactClass({

	render: function () {
        var photoNodes = this.props.contentSlot.fields.photos ? this.props.contentSlot.fields.photos.map(function(photo, index){
            return <Photo photo={photo} key={index} />;
        }) : [];

        var embedNode = null;
        var isIframe = false;
        if(this.props.contentSlot.fields.externalLink || this.props.contentSlot.fields.embeddableLinkVideoAudio){
            switch (this.props.contentSlot.fields.embeddableLinkVideoAudio && this.props.contentSlot.fields.embeddableLinkVideoAudio.fields.file.contentType) {
                case 'video/mp4':
                    embedNode = <Video video={this.props.contentSlot.fields.embeddableLinkVideoAudio} key={this.props.contentSlot.fields.embeddableLinkVideoAudio.sys.id} />
                    break;
                case 'audio/mpeg':
                    embedNode = <Audio audio={this.props.contentSlot.fields.embeddableLinkVideoAudio} key={this.props.contentSlot.fields.embeddableLinkVideoAudio.sys.id} />
                    break;
                default:
                    isIframe = true;
                    embedNode = <div className="iframe-placeholder" key={this.props.contentSlot.sys.id}><iframe src={this.props.contentSlot.fields.externalLink || this.props.contentSlot.fields.embeddableLinkVideoAudio.fields.file.url} allowFullScreen title=" " /></div>
            }
        }

        return (
            <div className={isIframe ? 'iframe-wrap' : ''}>
                {this.props.layoutType === 'Text' &&
                    photoNodes.concat(embedNode)
                }
                {this.props.contentSlot.fields.text &&
                    <ContentMarkDown payload={this.props.contentSlot.fields.text} />
                }
                {this.props.layoutType !== 'Text' &&
                    photoNodes.concat(embedNode)
                }
            </div>
        );
    }
});

module.exports = ContentSlot;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/contentSlot.jsx